// removed by extract-text-webpack-plugin
module.exports = {"haplotype-wrapper":"haplotype-wrapper","ant-table-thead":"ant-table-thead","view-report-item":"view-report-item","haplotype-download":"haplotype-download","haplotype-result-table":"haplotype-result-table","result-image":"result-image"};


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/arrayPgt/haplotypeReport/index.scss
// module id = 1412
// module chunks = 0